import { j as h } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ h.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ h.jsx(
  "path",
  {
    d: "M29.474 14.45 20 4.977 5.082 19.895h3.339v16.842h6.316V24.105h10.526v12.632h6.316V19.895h3.339l-3.34-3.34V9.369h-2.104zM0 22 20 2l7.368 7.368V7.263h6.316v8.421L40 22h-6.316v16.838H23.158V26.206h-6.316v12.632H6.316V22z",
    fill: "currentColor"
  }
) });
export {
  s as D
};
